export enum FormType {
    REGISTRAR = 1,
    EDITAR = 2,
    CONSULTAR = 3,
    COPIAR = 4,
    ENVIAR = 5,
    SUBSANAR = 6,
    BUSCAR = 7
  }
  